
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, ViewChild, Renderer2, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { InnerMenuLiveProcessService } from '../../inner-menu-liveprocess.service';
import { CommonService } from '../../../shared/service/shared.service';
import { ProcessItem, LiveProcessRequest } from '../../../shared/models/process.model';
import { CancelProcessComponent } from '../../../popup/cancel-process/cancel-process.component';

declare const $: any;

@Component({
    selector: 'liveprocess',
    templateUrl: './liveprocess.component.html',
    styleUrls: ['./liveprocess.component.css']
})
export class LiveProcessComponent extends SiriusBaseComponent<any> {
    @ViewChildren('elementTitles') elementTitles: QueryList<ElementRef>;
    @ViewChild('cancelPopup') cancelPopup: CancelProcessComponent;
    pageIndex: number;
    titleText: string = "";
    searchResultData: ProcessItem[] = [];
    noResult: boolean = false;
    selectedProcess: ProcessItem;
    cancelButtonText: string = "";
    cancelDisabled: boolean = false;
    /* String Resource */
    liveProcess_Title1: string;
    liveProcess_Title2: string;
    liveProcess_Title3: string;
    liveProcess_FirmReference: string; 
    liveProcess_ProductNo: string;
    liveProcess_ProcessType: string;
    liveProcess_ProcessTypeValue1: string;
    liveProcess_ProcessTypeValue2: string;
    liveProcess_TotalAmount: string;
    liveProcess_ProcessStatus: string;
    liveProcess_Detail: string;
    liveProcess_NoRecords: string;
    liveProcess_BackButton: string;
    liveProcess_ActionDetail: string;
    liveProcess_CancelButton1: string;
    liveProcess_CancelButton2: string;
    liveProcess_StatusText1: string;
    liveProcess_StatusText2: string;
    liveProcess_StatusText3: string;
    liveProcess_StatusText4: string;
    liveProcess_StatusText5: string;
    liveProcess_StatusText6: string;
    liveProcess_StatusText7: string;
    liveProcess_StatusText9: string;
    constructor(private innerMenuLiveProcessService: InnerMenuLiveProcessService, private commonService: CommonService, private renderer: Renderer2) {
        super();
    }
    OnInit() {
        this.setStringResource(); 
        this.pageIndex = 0;
        this.titleText = this.liveProcess_Title1;     
        this.commonService.selectedProcessDetail = null;
        this.commonService.selectedProcessAction = null;   
        this.searchProcess();       
    }
    setStringResource() {
        this.liveProcess_Title1 = this.resourceService.getResource("liveProcess_Title1");
        this.liveProcess_Title2 = this.resourceService.getResource("liveProcess_Title2");
        this.liveProcess_Title3 = this.resourceService.getResource("liveProcess_Title3");
        this.liveProcess_FirmReference = this.resourceService.getResource("liveProcess_FirmReference");
        this.liveProcess_ProductNo = this.resourceService.getResource("liveProcess_ProductNo");
        this.liveProcess_ProcessType = this.resourceService.getResource("liveProcess_ProcessType");
        this.liveProcess_ProcessTypeValue1 = this.resourceService.getResource("liveProcess_ProcessTypeValue1");
        this.liveProcess_ProcessTypeValue2 = this.resourceService.getResource("liveProcess_ProcessTypeValue2");
        this.liveProcess_TotalAmount = this.resourceService.getResource("liveProcess_TotalAmount");
        this.liveProcess_ProcessStatus = this.resourceService.getResource("liveProcess_ProcessStatus");
        this.liveProcess_Detail = this.resourceService.getResource("liveProcess_Detail");
        this.liveProcess_NoRecords = this.resourceService.getResource("liveProcess_NoRecords");
        this.liveProcess_BackButton = this.resourceService.getResource("liveProcess_BackButton");
        this.liveProcess_ActionDetail = this.resourceService.getResource("liveProcess_ActionDetail");
        this.liveProcess_CancelButton1 = this.resourceService.getResource("liveProcess_CancelButton1");
        this.liveProcess_CancelButton2 = this.resourceService.getResource("liveProcess_CancelButton2");
        this.liveProcess_StatusText1 = this.resourceService.getResource("liveProcess_StatusText1");
        this.liveProcess_StatusText2 = this.resourceService.getResource("liveProcess_StatusText2");
        this.liveProcess_StatusText3 = this.resourceService.getResource("liveProcess_StatusText3");
        this.liveProcess_StatusText4 = this.resourceService.getResource("liveProcess_StatusText4");
        this.liveProcess_StatusText5 = this.resourceService.getResource("liveProcess_StatusText5");
        this.liveProcess_StatusText6 = this.resourceService.getResource("liveProcess_StatusText6");
        this.liveProcess_StatusText7 = this.resourceService.getResource("liveProcess_StatusText7");
        this.liveProcess_StatusText9 = this.resourceService.getResource("liveProcess_StatusText9");
    }
    getTypeText(type) {
        return type == "S" ? this.liveProcess_ProcessTypeValue1 : this.liveProcess_ProcessTypeValue2;
    }
    getStatusText(status) {
        let text = "";
        switch (status) {
            case "1":
                text = this.liveProcess_StatusText1;
                break;
            case "2":
                text = this.liveProcess_StatusText2;
                break;
            case "3":
                text = this.liveProcess_StatusText3;
                break;
            case "4":
                text = this.liveProcess_StatusText4;
                break;
            case "5":
                text = this.liveProcess_StatusText5;
                break;
            case "6":
                text = this.liveProcess_StatusText6;
                break;
            case "7":
                text = this.liveProcess_StatusText7;
                break;
            case "9":
                text = this.liveProcess_StatusText9;
                break;
        }
        return text;
    }
    searchProcess() {
        var liveProcessRequest: LiveProcessRequest = {
            StartDate: null,
            EndDate: null,
      }
      var promise = this.innerMenuLiveProcessService.getUserLiveProcess(this.dataService, liveProcessRequest).toPromise();
        promise.then((result) => {
            if (result != null && Array.isArray(result) && result.length > 0) {
                this.searchResultData = result as Array<ProcessItem>;
            }
            else {
                this.noResult = true;
                this.searchResultData = null;
            }
        });
    }
    goProcessDetail(index: number) {
        this.cancelDisabled = false;
        this.selectedProcess = this.searchResultData[index];
        this.pageIndex = this.pageIndex + 1;
    }
    elementTitleClicked(i: number) {
        var elementList = this.elementTitles.toArray();
        for (let j = 0; j < elementList.length; j++) {
            if (j == i) {
              if (elementList[j].nativeElement.children[0].classList.contains("open")) {
                this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
                this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
              }
              else {
                this.renderer.addClass(elementList[j].nativeElement.children[0], 'open');
                this.renderer.addClass(elementList[j].nativeElement.children[1], 'show');
              }
            }
            else {
                this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
                this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
            }
        }
        $(document).ready(() => {
            $(".list-group").animate({ scrollTop: $('#elementTitleOfSearchResult' + i).height() * i }, 600);
        });
    }
    backButtonClicked() {
        this.pageIndex = this.pageIndex - 1;
        if (this.pageIndex == 0) {
            this.titleText = this.liveProcess_Title1;
        }
        else {
            this.titleText = this.liveProcess_Title2;
        }
    }
    nextButtonClicked() {
        this.pageIndex = this.pageIndex + 1;
        if (this.pageIndex == 1) {
            this.titleText = this.liveProcess_Title2;
        }
        else {
            this.titleText = this.liveProcess_Title3;
        }  
    }    
    cancelProcess() {
        this.cancelPopup.showPopup();
    }
    onProcessCancel() {
        this.cancelDisabled = true;
        this.searchResultData = this.searchResultData.filter(x => x.FirmReference != this.selectedProcess.FirmReference);
        if (this.searchResultData.length == 0)
            this.noResult = true;
    }
}
